import { render } from "./AutosizeTextarea.vue?vue&type=template&id=2f9d95e8"
import script from "./AutosizeTextarea.vue?vue&type=script&lang=js"
export * from "./AutosizeTextarea.vue?vue&type=script&lang=js"
script.render = render

export default script